module.exports = __webpack_public_path__ + "img/svg/background-menu.e41c5123f4fa8eb3b8d8d04d07c93db2.svg";